import './index.scss';

import React from "react";
import Label from "../../atoms/label";
import {price} from "../../../util/formatting";

class CartShippingNotice extends React.Component {
    static defaultProps = {
        cart: null,
    };
    
    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className={'cart-shipping-notice'}>
                <div className="cart-shipping-notice__label">
                    <Label title="Retour"/>
                </div>
                <div className="list-item__column list-item__column--valign-top list-item__column--clean list-item__column--span-5">
                    This cart contains an item to refund
                </div>
                <div className="list-item__column list-item__column--span-3">
                    &nbsp;
                </div>
                <div className="list-item__column list-item__column--span-2">
                    &nbsp;
                </div>
            </div>
        );
    }
}

export default CartShippingNotice;